import React from 'react'

import { BASE_URL } from '../../constants'

import { useIncidents } from '../hooks'

import HCFRIncidentListItem from './HCFRIncidentListItem'

import styles from './HCFRIncidentList.module.css'

const HCFRIncidentList = () => {
  const [
    { response: incidents, error, isLoading },
    { refresh },
  ] = useIncidents()

  return (
    <div>
      <h1 className={styles.header}>
        <img
          alt="HCFR Logo"
          src={`${BASE_URL}images/HCFR-logo.png`}
          className={styles.logo}
        />{' '}
        HCFR Active Incidents{' '}
        {isLoading && <small style={{ color: '#411' }}>Loading...</small>}
      </h1>
      {error && <div>{error}</div>}
      <table className={styles.list}>
        <thead>
          <tr>
            <th>Incident Number</th>
            <th>Time</th>
            <th>Location</th>
            <th>Area Name</th>
            <th>Incident Code</th>
            <th>Incident Type</th>
          </tr>
        </thead>
        <tbody>
          {incidents &&
            incidents.map((i) => (
              <HCFRIncidentListItem key={i.incidentNumber} incident={i} />
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default HCFRIncidentList
